export class DateUtil {
  public static getFirstDayTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  public static getLastDayTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, -1);
  }

  // Convert from UTC to local
  public static convertFromUTCToLocal(dateInput: string): string {
    dateInput = dateInput + 'Z';
    let date = new Date(dateInput);

    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);  // Months are 0-based
    let day = ("0" + date.getDate()).slice(-2);
    let hours = ("0" + date.getHours()).slice(-2);
    let minutes = ("0" + date.getMinutes()).slice(-2);
    let seconds = ("0" + date.getSeconds()).slice(-2);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  // Convert from local to UTC split milliseconds
  public static convertFromLocalToUTCSplitMiliseconds(dateinput: Date) {
    const year = dateinput.getFullYear();
    const month = String(dateinput.getMonth() + 1).padStart(2, '0');
    const day = String(dateinput.getDate()).padStart(2, '0');
    const hours = String(dateinput.getHours()).padStart(2, '0');
    const minutes = String(dateinput.getMinutes()).padStart(2, '0');
    const seconds = String(dateinput.getSeconds()).padStart(2, '0');
    const milliseconds = String(dateinput.getMilliseconds()).padStart(3, '0');

    return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`);
  }

  // Add hours to UTC
  public static addHoursToUTC(dateInput: Date): Date {
    const localOffsetInMs = dateInput.getTimezoneOffset() * 60000;
    const offsetInMs = localOffsetInMs;
    const adjustedDateInMs = dateInput.getTime() + offsetInMs;
    return new Date(adjustedDateInMs);
  }

  // Set type calendar AM or PM
  public static setTypeCalendar(dateInput: any) {
    const date = dateInput.substring(11);
    const hours = Number(date.split(':')[0]);
    return hours >= 12 ? 'PM' : 'AM';
  }


  //--------------------------------------------------------------------------------
  // Convert from local to UTC input string
  public static convertFromLocalToUTC(dateString, onlyUTC = false, addOffset = true) {
    let dateToReturn = dateString;

    // Convert to UTC
    if (!this.dateIsUTC(dateString)) {
      let date = new Date(dateString);
      dateToReturn = date.toISOString().substring(0, 19) + 'Z';
    }

    if (typeof dateToReturn === 'string' && !(dateToReturn.endsWith('AM') || dateToReturn.endsWith('PM')) && !dateToReturn.endsWith('Z'))
      dateToReturn = dateToReturn + 'Z';

    dateToReturn = this.addOffset(dateToReturn, onlyUTC, addOffset);
    return dateToReturn;
  }

  // add offset to date
  // addOffset: true example => input 2024-08-27T16:09:43Z, output 2024-08-27T11:09:43Z para mostrar
  // addOffset: false example => input 2024-08-27T16:09:43Z, output 2024-08-27T21:09:43Z para guardar
  public static addOffset(dateString, onlyUTC = false, addOffset = true) {
    let dateToReturn = dateString;
    const storedServerTimeDifference = sessionStorage.getItem('serverTimeDifference');
    if (storedServerTimeDifference && !onlyUTC) {
      const offsetSign = storedServerTimeDifference[3];
      const offsetHours = parseInt(storedServerTimeDifference.substring(4, 6), 10);
      const offsetMinutes = parseInt(storedServerTimeDifference.substring(7, 9), 10);
      const totalOffsetMinutes = (offsetHours * 60 + offsetMinutes) * (offsetSign === '+' ? 1 : -1);

      let date = new Date(dateString);
      const adjustedDateInMs = addOffset ?
        date.getTime() + totalOffsetMinutes * 60 * 1000 : date.getTime() - totalOffsetMinutes * 60 * 1000;
      const newDate = new Date(adjustedDateInMs);
      dateToReturn = newDate.toISOString().substring(0, 19) + 'Z';
    }
    return dateToReturn;
  }


  // is date in UTC?
  public static dateIsUTC(dateString: string): boolean {
    const hasTimeZoneOffset = /[+-]\d{2}:\d{2}$/.test(dateString);
    return !hasTimeZoneOffset;
  }

  // MM/DD/YYYY HH:mm PM/AM
  public static formatAMPM(dateString, firstDay = false) {
    let month, day, year, hours, minutes: string;
    let dateToReturn = this.convertFromLocalToUTC(dateString);
    const date = new Date(dateToReturn);

    month = String(date.getUTCMonth() + 1).padStart(2, '0');
    day = String(date.getUTCDate()).padStart(2, '0');
    year = date.getUTCFullYear();
    hours = date.getUTCHours();
    minutes = String(date.getUTCMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strHours = String(hours).padStart(2, '0');
    if (firstDay)
      return `${day}/${month}/${year} ${strHours}:${minutes} ${ampm}`;
    else
      return `${month}/${day}/${year} ${strHours}:${minutes} ${ampm}`;
  }

  // MM/DD/YYYY
  public static formatAMPMDate(dateString) {
    let date = this.formatAMPM(dateString);
    return date.substring(0, 10);
  }

  // HH:mm
  public static showTimeOnly(dateString) {
    return dateString.substring(11, 16);
  }

  // HH:mm PM/AM
  public static formatAMPMTime(dateString) {
    let date = this.formatAMPM(dateString);
    return date.substring(10);
  }

  // Correct hour to save or show, depends serverTimeDifference
  // To show => flag true
  // To save => flag false
  public static calculateHoursToShowOrSave(hour, show) {
    const storedServerTimeDifference = sessionStorage.getItem('serverTimeDifference');
    const offsetSign = storedServerTimeDifference[3];
    const offsetHours = parseInt(storedServerTimeDifference.substring(4, 6), 10);
    let hourInput = parseInt(hour);

    if ((show && offsetSign === '+') || (!show && offsetSign === '-')) {
      let hourOutput = hourInput + offsetHours;
      if (hourOutput > 23)
        hourOutput = hourOutput - 24;
      return hourOutput;
    }
    if ((show && offsetSign === '-') || (!show && offsetSign === '+')) {
      let hourOutput = hourInput - offsetHours;
      if (hourOutput < 0)
        hourOutput = hourOutput + 24;
      return hourOutput;
    }
  }

  // Correct minutes to save or show, depends serverTimeDifference
  // To show => flag true
  // To save => flag false
  public static calculateMinutesToShowOrSave(minutes, show) {
    const storedServerTimeDifference = sessionStorage.getItem('serverTimeDifference');
    const offsetSign = storedServerTimeDifference[3];
    const offsetMinutes = parseInt(storedServerTimeDifference.substring(7, 9), 10);
    let minutesInput = parseInt(minutes);

    if ((show && offsetSign === '+') || (!show && offsetSign === '-')) {
      let minutesOutput = minutesInput + offsetMinutes;
      if (minutesOutput > 59)
        minutesOutput = minutesOutput - 60;
      return minutesOutput;
    }
    if ((show && offsetSign === '-') || (!show && offsetSign === '+')) {
      let minutesOutput = minutesInput - offsetMinutes;
      if (minutesOutput < 0)
        minutesOutput = minutesOutput + 60;
      return minutesOutput;
    }
  }

  // Set time to 00:00:00 in UTC and then add offset
  public static setFirstHourDay(date: Date): Date {
    const convertedTime = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
    return this.convertFromLocalToUTC(convertedTime, false, false);
  }

  // Set time to 23:59:59 in UTC and then add offset
  public static setLastHourDay(date: Date): Date {
    const convertedTime = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 0));
    return this.convertFromLocalToUTC(convertedTime, false, false);
  }

  // Convert from local to UTC full milliseconds YYYY-MM-DDTHH:mm:ss.sssssss
  public static convertFromLocalToUTCFullMiliseconds(dateString: string, onlyUTC = false): string {
    const milliseconds = dateString.split('.')[1].split(/[-+]/)[0];
    const dateStringFullMilliseconds = this.convertFromLocalToUTC(dateString, onlyUTC);
    return dateStringFullMilliseconds.replace('Z', `.${milliseconds}`);
  }

  // Enter date "UTC", add offset
  public static inDateAddOffset(dateinput: Date) {
    const year = dateinput.getFullYear();
    const month = String(dateinput.getMonth() + 1).padStart(2, '0');
    const day = String(dateinput.getDate()).padStart(2, '0');
    const hours = String(dateinput.getHours()).padStart(2, '0');
    const minutes = String(dateinput.getMinutes()).padStart(2, '0');
    const seconds = String(dateinput.getSeconds()).padStart(2, '0');
    const milliseconds = String(dateinput.getMilliseconds()).padStart(3, '0');
    const newDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    const dateStringFullMilliseconds = this.convertFromLocalToUTC(newDate);
    return dateStringFullMilliseconds;
  }

  // Enter date return string date, no add offset
  public static converDateToStringNoAddOffset(dateinput) {
    if (typeof dateinput === 'string') return dateinput;
    
    const year = dateinput.getFullYear();
    const month = String(dateinput.getMonth() + 1).padStart(2, '0');
    const day = String(dateinput.getDate()).padStart(2, '0');
    const hours = String(dateinput.getHours()).padStart(2, '0');
    const minutes = String(dateinput.getMinutes()).padStart(2, '0');
    const seconds = String(dateinput.getSeconds()).padStart(2, '0');
    const milliseconds = String(dateinput.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }

  public static returnHoursMinutes(dateinput) {
    if (typeof dateinput === 'string') return dateinput;
    const hours = String(dateinput.getHours()).padStart(2, '0');
    const minutes = String(dateinput.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  public static returnHoursMinutesFromString(dateinput) {
    if (dateinput.includes('T')) {
      dateinput = dateinput.split('T')[1];
    }
    const [hours, minutes] = dateinput.split(':').map(Number);
    const hoursStr = String(hours).padStart(2, '0');
    const minutesStr = String(minutes).padStart(2, '0');
    return `${hoursStr}:${minutesStr}`;
  }

  // Add hours to UTC
  public static getHoursToUTCAddOffset(dateInput: Date): number {
    const localOffsetInMs = dateInput.getTimezoneOffset() * 60000;

    // Ajustar la fecha sumando el offset
    const adjustedDateInMs = dateInput.getTime() + localOffsetInMs;
    const adjustedDate = new Date(adjustedDateInMs);

    // Devolver solo el nuevo valor de la hora
    return adjustedDate.getHours() > 12 ? adjustedDate.getHours() - 12 : adjustedDate.getHours();
  }

  // Return a date with the offset added
  public static convertFromLocalToUTCReturnDate(dateString, onlyUTC = false) {
    const dateTimezone = DateUtil.convertFromLocalToUTC(dateString, onlyUTC);
    const utcDate = new Date(dateTimezone);

    const localOffsetInMs = utcDate.getTimezoneOffset() * 60000;
    const adjustedDateInMs = utcDate.getTime() + localOffsetInMs;

    const adjustedDate = new Date(adjustedDateInMs);
    return adjustedDate;
  }

  // return the next format {hours: 12, minutes: 0, seconds: 0, period: 'AM'} to avoid use genome
  public static getTimeFromDate(date: any) {
    const formatReturned = {
      hours: 12,
      minutes: 0,
      seconds: 0,
      period: 'AM'
    };
    formatReturned.hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
    if (formatReturned.hours === 0)
      formatReturned.hours = 12;
    formatReturned.minutes = date.getMinutes();
    formatReturned.seconds = date.getSeconds();
    formatReturned.period = date.getHours() >= 12 ? 'PM' : 'AM';
    return formatReturned;
  }

  public static setTimeToDate(date: Date, time) {
    if (date && time) {
      let militaryHours: number;

      if (time.period === 'PM' && time.hours < 12) {
        militaryHours = time.hours + 12;
      }
      else if (time.period === 'AM' && time.hours === 12) {
        militaryHours = time.hours - 12;
      }
      else {
        militaryHours = time.hours;
      }

      date.setHours(militaryHours);
      date.setMinutes(time.minutes);
      date.setSeconds(time.seconds);
    }
  }

  // Date already UTC, but it is necessary remove offset
  public static alreadyUTCRemoveOffsetString(dateinput: Date) {
    const year = dateinput.getFullYear();
    const month = String(dateinput.getMonth() + 1).padStart(2, '0');
    const day = String(dateinput.getDate()).padStart(2, '0');
    const hours = String(dateinput.getHours()).padStart(2, '0');
    const minutes = String(dateinput.getMinutes()).padStart(2, '0');
    const seconds = String(dateinput.getSeconds()).padStart(2, '0');
    const milliseconds = String(dateinput.getMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }

  // Covert a date in a datetimeoffset format in UTC.
  public static ensureUTC(dateString: string): string {
    if (dateString) {
      const utcRegex = /(\d{4}-\d{2}-\d{2})([ T])(\d{2}:\d{2}:\d{2})(Z|[+-]\d{2}:\d{2})?$/;
      const match = dateString.match(utcRegex);

      if (match) {
        let formattedDate = match[1] + 'T' + match[3];
        if (!dateString.endsWith('Z') && !match[4]) {
          formattedDate += 'Z';
        }
        let date = new Date(formattedDate);
        if (dateString.endsWith('Z'))
          date = new Date(dateString);
        return date.toISOString();
      }
    }
    const date = new Date(dateString);
    return date.toISOString();
  }

  //dd/MM/yyyy
  public static formatDateShort(date: Date): string {
    const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);

    const day = String(adjustedDate.getDate()).padStart(2, '0');
    const month = String(adjustedDate.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son 0-indexados
    const year = adjustedDate.getFullYear();

    return `${year}-${month}-${day}`;
  }

    //yyyy-MM-dd-hh-mm
  public static formatDateLarge(date: Date): string {
      const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);
  
      const day = String(adjustedDate.getDate()).padStart(2, '0');
      const month = String(adjustedDate.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son 0-indexados
      const year = adjustedDate.getFullYear();
      const hours = String(adjustedDate.getHours()).padStart(2, '0');
      const minutes = String(adjustedDate.getMinutes()).padStart(2, '0');
  
      return `${year}-${month}-${day}-${hours}-${minutes}`;
  }

  //2024-08-26T19:00:00
  public static formatDateShortWithTimeUTC(date: Date): string {
    const adjustedDate = this.getDateInLocalTimeToUTC(date);

    const day = String(adjustedDate.getDate()).padStart(2, '0');
    const month = String(adjustedDate.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son 0-indexados
    const year = adjustedDate.getFullYear();
    const hours = String(adjustedDate.getHours()).padStart(2, '0');
    const minutes = String(adjustedDate.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:00`;
  }

  //19:00:00
  public static formatTimeWithTimeUTC(date: Date): string {
    const adjustedDate = this.getDateInLocalTimeToUTC(date);

    const hours = String(adjustedDate.getHours()).padStart(2, '0');
    const minutes = String(adjustedDate.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}:00`;
  }


  public static setHour(date: Date, hour: number): Date {
    const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);
    adjustedDate.setHours(hour);
    return this.getDateInConfiguredTimeToLocalTime(adjustedDate);
  }

  public static setMinutes(date: Date, hour: number): Date {
    const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);
    adjustedDate.setMinutes(hour);
    return this.getDateInConfiguredTimeToLocalTime(adjustedDate);
  }

  //set date in format yyyy-MM-dd
  public static setDate(date: Date, newDate: String): Date {
    const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);
    adjustedDate.setFullYear(Number(newDate.substring(0, 4)));
    adjustedDate.setMonth(Number(newDate.substring(5, 7)) - 1);
    adjustedDate.setDate(Number(newDate.substring(8, 10)));
    return this.getDateInConfiguredTimeToLocalTime(adjustedDate);
  }

  //HH
  public static getHour(date: Date): string {
    const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);
    return String(adjustedDate.getHours()).padStart(2, '0');
  }

  //MI
  public static getMinutes(date: Date): string {
    const adjustedDate = this.getDateInLocalTimeToConfiguredTime(date);
    return String(adjustedDate.getMinutes()).padStart(2, '0');
  }

  private static getDateInLocalTimeToConfiguredTime(date: Date): Date {
    const adjustedDate = new Date(date.getTime() + (date.getTimezoneOffset() + this.getConfiguredOffSetInMinutes()) * 60000);
    return adjustedDate;
  }

  private static getDateInLocalTimeToUTC(date: Date): Date {
    const adjustedDate = new Date(date.getTime() + (date.getTimezoneOffset()) * 60000);
    return adjustedDate;
  }


  private static getDateInConfiguredTimeToLocalTime(date: Date): Date {
    const adjustedDate = new Date(date.getTime() - (date.getTimezoneOffset() + this.getConfiguredOffSetInMinutes()) * 60000);
    return adjustedDate;
  }

  public static getConfiguredOffSetInMinutes(): number {
    const storedServerTimeDifference = sessionStorage.getItem('serverTimeDifference');
    if (!storedServerTimeDifference) {
      return 0;
    }
    const sign = storedServerTimeDifference[3] === '-' ? -1 : 1;
    const [hours, minutes] = storedServerTimeDifference.slice(4).split(':').map(Number);
    const offsetInMinutes = sign * (hours * 60 + minutes);
    return offsetInMinutes;
  }

  // Input date, return date, when you enter a date in a input, calculates offset
  public static returnDateToSave(dateinput: Date) {
    const serverTime = sessionStorage.getItem('serverTime');
    if (serverTime === 'UTC')
      return DateUtil.alreadyUTCRemoveOffsetString(dateinput);
    else {
      const dateUTC = DateUtil.alreadyUTCRemoveOffsetString(dateinput);
      return this.convertFromLocalToUTC(dateUTC, false, false);
    }
  }

  // Return custom format for traces new yyyyMMddHHmm
  public static getFormattedDate(dateinput: Date) {
    const dateUTC = DateUtil.alreadyUTCRemoveOffsetString(dateinput);
    const dateUTCOffset = this.convertFromLocalToUTC(dateUTC, false, false);
    const year = dateUTCOffset.substring(0, 4);
    const month = dateUTCOffset.substring(5, 7);
    const day = dateUTCOffset.substring(8, 10);
    const hours = dateUTCOffset.substring(11, 13);
    const minutes = dateUTCOffset.substring(14, 16);
    const formattedDate = `${year}${month}${day}${hours}${minutes}`;
    return formattedDate;
  }

  // Input yyyyMMddHHmm return MM/DD/YYYY HH:mm PM/AM
  public static getFormattedDateToShow(dateInput: string, firstDay = false) {
    const year = dateInput.substring(0, 4);
    const month = dateInput.substring(4, 6);
    const day = dateInput.substring(6, 8);
    const hours = dateInput.substring(8, 10);
    const minutes = dateInput.substring(10, 12);
    const dateUTC = `${year}-${month}-${day}T${hours}:${minutes}:00.000Z`;
    return this.formatAMPM(dateUTC, firstDay);
  }

  public static dateToShow(dateInput: string): Date {
    let dateToReturn = dateInput;
    if (!this.dateIsUTC(dateToReturn)) {
      let date = new Date(dateToReturn);
      dateToReturn = date.toISOString().substring(0, 19) + 'Z';
    }

    if (typeof dateToReturn === 'string' && !(dateToReturn.endsWith('AM') || dateToReturn.endsWith('PM')) && !dateToReturn.endsWith('Z'))
      dateToReturn = dateToReturn + 'Z';
    return this.convertFromLocalToUTCReturnDate(dateToReturn, false);
  }
  
  public static dateToMilitaryDate(dateInput: string):string{
    if (!dateInput) return null;
    // Ensure the date is in ISO UTC format
    let dateStr = dateInput;
    if (!this.dateIsUTC(dateStr)) {
      const date = new Date(dateStr);
      dateStr = date.toISOString().substring(0, 19) + 'Z';
    }
    if (typeof dateStr === 'string' && !(dateStr.endsWith('AM') || dateStr.endsWith('PM')) && !dateStr.endsWith('Z'))
      dateStr = dateStr + 'Z';
    const dateObj = new Date(dateStr);
    // Returns the date in military format: YYYY-MM-DD HH:mm:ss
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const hours = String(dateObj.getUTCHours()).padStart(2, '0');
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // DD/MM/YYYY HH:mm:ss
  public static formatDDMMYYYYWithSeconds(dateString) {
    let dateToReturn = this.convertFromLocalToUTC(dateString);
    const date = new Date(dateToReturn);

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
}
